export const stripNonNumerical = (val: string) => val.replace(/[^0-9]/g, '');
